import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class HeaderService {
  public selectedOrgDetails: any;
  public router: any;
  private systemProperties: Promise<any>;

  constructor(private _http: HttpClient) {}

  logout() {
    return this._http
      .post(`/api/logout`, {})
      .toPromise()
      .then(value => {
        sessionStorage.clear();
        return value;
      });
  }

  getSystemProperties(): Promise<any> {
    if (this.systemProperties) {
      return this.systemProperties;
    }
    const observable = this._http.get(`/api/SystemProperties/getSystemProps`);
    return observable.toPromise().then(data => {
      this.systemProperties = Promise.resolve(data);
      return data;
    });
  }

  setSelectedOrgDetails(selectedOrg) {
    this.selectedOrgDetails = selectedOrg;
  }

  getselectedOrgDetails() {
    return this.selectedOrgDetails || {};
  }

  setRouter(router) {
    this.router = router;
  }

  getRouter() {
    return this.router || {};
  }

  getConfigPropertyValue(key: string): Observable<Object> {
    return this._http.get(`/api/ConfigUtilService/getPropertyValue`, {
      params: { key: key },
      responseType: "json",
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/header.service.ts